import api from "../../api";

const state = {

};

const getters = {};

const mutations = {};

const actions = {
    getAllTalents({ commit, rootGetters }, data) {
        return new Promise((resolve, reject) => {
          commit("make_request", null, { root: true });
          api({
            url: `users/talents?offset=${data.offset}&limit=${data.limit}`,
            method: "GET",
            withCredentials: true,
            headers: {
              Authorization: rootGetters.authToken,
            },
          })
            .then((resp) => {
              commit("request_success", null, { root: true });
              resolve(resp);
            })
            .catch((err) => {
              commit("request_error", null, { root: true });
              reject(err);
            });
        });
      },

    getUser({ commit, rootGetters }, data) {
        return new Promise((resolve, reject) => {
            commit("make_request", null, { root: true });
            api({
            url: `users/${data.uid}`,
            method: "GET",
            withCredentials: true,
            headers: {
                Authorization: rootGetters.authToken,
            },
            })
            .then((resp) => {
                commit("request_success", null, { root: true });
                resolve(resp);
            })
            .catch((err) => {
                commit("request_error", null, { root: true });
                reject(err);
            });
        });
    },
};

export const users = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
